import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import {
    buscarAreasConfiguracion,
    crearOrganizadorConfiguracion
} from '../../../actions/configuracion';

const NuevoOrganizador = ({ organizador, reestablecerOrganizador, idAreaVista }) => {

    const dispatch = useDispatch();

    const { listado: listadoAreas } = useSelector(state => state.configuracion.areas);

    const [show, setShow] = useState(false);
    const [idArea, setIdArea] = useState('');
    const [nombre, setNombre] = useState('');

    useEffect(() => {
        if (!listadoAreas || listadoAreas.length === 0) {
            dispatch(buscarAreasConfiguracion());
        }
    }, [dispatch, listadoAreas]);

    useEffect(() => {
        if (organizador) {
            setShow(true);
            setNombre('');
            setIdArea(idAreaVista); // por default el área actual
        } else {
            setShow(false);
        }
    }, [organizador, idAreaVista]);

    const handleClose = () => {
        setShow(false);
        setNombre('');
        setIdArea('');
        reestablecerOrganizador(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!nombre.trim() || !idArea) return;

        const resp = await dispatch(
            crearOrganizadorConfiguracion({
                id_area: idArea,
                nombre: nombre.trim(),
                idAreaVista
            })
        );

        if (resp && resp.success) {
            handleClose();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <form onSubmit={handleSubmit}>
                <div className="modal-header">
                    <h5 className="modal-title">Agregar organizador</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleClose}
                        aria-label="Close"
                    ></button>
                </div>

                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label">Área</label>
                        <select
                            className="form-select"
                            value={idArea}
                            onChange={e => setIdArea(e.target.value)}
                        >
                            <option value="">Seleccione un área</option>
                            {listadoAreas && listadoAreas.filter(a => a._id).map(a => (
                                <option key={a._id} value={a._id}>
                                    {a.nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Nombre</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nombre del organizador"
                            value={nombre}
                            onChange={e => setNombre(e.target.value)}
                        />
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleClose}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default NuevoOrganizador;
